/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1901887531 — OldTabScreen */

import { useTranslation } from 'react-i18next';

import { ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { usePageTracking } from '../../../../shared/hooks/usePageTracking';

interface OldTabScreenProps {
    title?: string;
}

export const OldTabScreen = ({ title }: OldTabScreenProps) => {
    const { t } = useTranslation();

    usePageTracking(title || 'old tab');

    return (
        <ScreenWrapper>
            <ScreenTitle>{t(title || 'Failed sale')}</ScreenTitle>
            <ContentBox />
        </ScreenWrapper>
    );
};
